/**
 * Handle rules — the ONE definition of what a valid profile handle is, shared
 * by the updateMyProfile handler (server enforcement) and the portal's
 * account/claim forms (inline mirror). Handles are stored canonical-lowercase
 * (`canonicalHandle`), and migration 0022 backs uniqueness with a UNIQUE index
 * on lower(handle).
 */

export const HANDLE_MIN_LEN = 2;
export const HANDLE_MAX_LEN = 20;

/** Canonical (already-lowercased) handle shape: alnum start, then [a-z0-9_-]. */
export const HANDLE_PATTERN = /^[a-z0-9][a-z0-9_-]*$/;

/** Canonicalize raw input: trim + lowercase (validation runs on THIS form). */
export const canonicalHandle = (raw: string): string => raw.trim().toLowerCase();

/** True when `handle` (canonical form) satisfies the handle rules. */
export function isValidHandle(handle: string): boolean {
  return (
    handle.length >= HANDLE_MIN_LEN &&
    handle.length <= HANDLE_MAX_LEN &&
    HANDLE_PATTERN.test(handle)
  );
}
